/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuditTrailSummaryViewModel } from './AuditTrailSummaryViewModel';
import {
    AuditTrailSummaryViewModelFromJSON,
    AuditTrailSummaryViewModelFromJSONTyped,
    AuditTrailSummaryViewModelToJSON,
} from './AuditTrailSummaryViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfAuditTrailSummaryViewModel
 */
export interface ResultOfListOfAuditTrailSummaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<AuditTrailSummaryViewModel>}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    data?: Array<AuditTrailSummaryViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfAuditTrailSummaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfAuditTrailSummaryViewModel interface.
 */
export function instanceOfResultOfListOfAuditTrailSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfAuditTrailSummaryViewModelFromJSON(json: any): ResultOfListOfAuditTrailSummaryViewModel {
    return ResultOfListOfAuditTrailSummaryViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfAuditTrailSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfAuditTrailSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(AuditTrailSummaryViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfAuditTrailSummaryViewModelToJSON(value?: ResultOfListOfAuditTrailSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AuditTrailSummaryViewModelToJSON)),
        'Count': value.count,
    };
}

